var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('vue-qr',{ref:"qr",staticStyle:{"width":"100px","height":"100px"},attrs:{"text":_vm.url,"margin":10,"size":600,"logoScale":0.25}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }